import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import { Link } from '../../../routes';
import Container from '../../container';
import Waves from '../../waves';
import PartnerGrid from '../../partner-grid';
import RenderMd from '../../render-md';
import TextWave from '../../text-wave';

const CaseStudyGrid = (props) => {
  const hasRelated = !!props.related;

  return (
    <CaseStudySection hasRelated={hasRelated}>
      <Container>
        <TextWave>
          <h2>{props.title}</h2>
        </TextWave>
        <Description>
          <RenderMd source={props.description} />
        </Description>

        <PartnerGrid partnerList={props.related} />

        {props.related &&
          <Link route="/partners" passHref>
            <ViewAllLink>View All</ViewAllLink>
          </Link>
        }

      </Container>

      <Waves
        position="bottom"
        alignment="bottom"
        height={330}
      />
    </CaseStudySection>
  );
};

const CaseStudySection = styled.section`
  position: relative;
  padding: 160px 0 380px;
  text-align: center;

  h2 {
    margin-bottom: 75px;

    ${screen.below(bp.mobile, `
      margin-bottom: 40px;
    `)}
  }

  ${screen.below(bp.portrait, `
    padding: 162px 0 300px;
  `)}

  ${screen.below(bp.mobile, `
    padding: 100px 0 230px;
  `)}

  ${props => !props.hasRelated && css`
    padding-top: 0;
  `}
`;

const Description = styled.div`
  max-width: 790px;
  margin: auto;
`;

const ViewAllLink = styled.a`
  display: inline-block;
  margin-top: 120px;

  ${screen.below(bp.portrait, `
    margin-top: 100px;
  `)}

  ${screen.below(bp.mobile, `
    margin-top: 80px;
  `)}
`;

CaseStudyGrid.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  related: PropTypes.array,
};

export default CaseStudyGrid;
